import { State } from './State';

export abstract class CompositeState extends State {
  abstract getChild(index: number): State;
}
